// import dummyState from "App/common/dummies/backup_setting";
import initState from "./initState";

import * as types from "./types";
import {
  updateObject,
  insertItem,
  insertMultipleItems,
  removeItem,
  convertHMToSecs,
  deepClone,
  sortNumbers,
  createNumberRange
} from "utils";
import { STATIC_VARIABLES } from "consts";

function toggleScheduleType(state, action) {
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      type: { current: action.val, past: state.scheduleInfo.type.current },
      ...(action.val === 1 ? { weekDays: createNumberRange(7, 0) } : {})
    })
  });
}

function toggleScheduleInterval(state, action) {
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      interval: updateObject(state.scheduleInfo.interval, {
        selected: +action.val
      })
    })
  });
}

function toggleScheduleStartTime(state, action) {
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      startTime: updateObject(state.scheduleInfo.startTime, {
        value: action.val
      })
    })
  });
}

function toggleScheduleDays(state, action) {
  let weekDays = [...state.scheduleInfo.weekDays];
  let areAllDaysSelected = false;
  if (Array.isArray(action.val)) {
    if (action.val.length === 7) {
      areAllDaysSelected = true;
    }
    weekDays = action.val;
  } else if (weekDays.includes(action.val))
    weekDays = removeItem(weekDays, weekDays.indexOf(action.val));
  else {
    if (weekDays.length === 6) {
      areAllDaysSelected = true;
    }
    weekDays.push(action.val);
  }

  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      ...(areAllDaysSelected
        ? { type: { current: 1, past: state.scheduleInfo.type.current } }
        : {}),
      weekDays: weekDays
    })
  });
}

function toggleScheduleMonths(state, action) {
  let months = [...state.scheduleInfo.months];
  if (action.val === "all" && months.length === 12) {
    months = [];
  } else if (action.val === "all" && months.length < 12) {
    months = createNumberRange(12);
  } else if (months.includes(action.val)) {
    months = removeItem(months, months.indexOf(action.val));
  } else {
    months.push(action.val);
    months = sortNumbers(months);
  }
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      months
    })
  });
}

function toggleScheduleMonthDays(state, action) {
  let monthDays = [...state.scheduleInfo.monthDays];
  if (action.val === "all" && monthDays.length === 32) {
    monthDays = [];
  } else if (action.val === "all" && monthDays.length < 32) {
    monthDays = createNumberRange(32);
  } else if (monthDays.includes(action.val)) {
    monthDays = removeItem(monthDays, monthDays.indexOf(action.val));
  } else {
    monthDays.push(action.val);
    monthDays = sortNumbers(monthDays);
  }
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      scheduleChanged: true,
      monthDays
    })
  });
}

function toggleScheduleRetention(state, action) {
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      retention: updateObject(state.scheduleInfo.retention, {
        [action.retentionType]: parseInt(action.val)
      })
    })
  });
}

function toggleScheduleDevice(state, action) {
  if (action.activityType === "onWakeup")
    return updateObject(state, {
      scheduleInfo: updateObject(state.scheduleInfo, {
        advanced: updateObject(state.scheduleInfo.advanced, {
          onWakeup: updateObject(state.scheduleInfo.advanced.onWakeup, {
            checked: !state.scheduleInfo.advanced.onWakeup.checked
          })
        })
      })
    });
  else
    return updateObject(state, {
      scheduleInfo: updateObject(state.scheduleInfo, {
        advanced: updateObject(state.scheduleInfo.advanced, {
          [action.activityType]: !state.scheduleInfo.advanced[
            action.activityType
          ]
        })
      })
    });
}

function toggleScheduleLoginDetails(state, action) {
  return updateObject(state, {
    scheduleInfo: updateObject(state.scheduleInfo, {
      advanced: updateObject(state.scheduleInfo.advanced, {
        onWakeup: updateObject(state.scheduleInfo.advanced.onWakeup, {
          [action.detailsType]: action.val
        })
      })
    })
  });
}

function toggleNotificationEnable(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      enabled: !state.emailNotification.enabled,
      emails: { list: [] }
    })
  });
}

function changeNotificationCurrentEmail(state, action) {
  let input = action.val.trim();
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      emails: updateObject(state.emailNotification.emails, {
        current: input
      })
    })
  });
}

function addNotificationEmail(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      emails: updateObject(state.emailNotification.emails, {
        current: "",
        list: insertItem(
          state.emailNotification.emails.list,
          state.emailNotification.emails.current
        )
      })
    })
  });
}

function addMultipleNotificationEmail(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      emails: updateObject(state.emailNotification.emails, {
        current: action.wrongEmails,
        list: insertMultipleItems(
          state.emailNotification.emails.list,
          action.correctEmails
        )
      })
    })
  });
}

function removeNotificationEmail(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      emails: updateObject(state.emailNotification.emails, {
        list: removeItem(state.emailNotification.emails.list, action.index)
      })
    })
  });
}

function changeNotificationSMTPSetting(state, action) {
  if ((action.settingType === "port" && +action.val < 0) || +action.val > 65535)
    return state;
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      smtpSettings: updateObject(state.emailNotification.smtpSettings, {
        [action.settingType]:
          action.settingType === "port" ? parseInt(action.val) : action.val
      })
    })
  });
}

function toggleNotificationOperationStatus(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      operationStatus: updateObject(state.emailNotification.operationStatus, {
        [action.statusType]: !state.emailNotification.operationStatus[
          action.statusType
        ]
      })
    })
  });
}

function toggleNotificationOnDesktop(state, action) {
  return updateObject(state, {
    emailNotification: updateObject(state.emailNotification, {
      notifyOnDesktop: !state.emailNotification.notifyOnDesktop
    })
  });
}

function toggleSourceType(state, action) {
  const volumes = JSON.parse(JSON.stringify(state.volumes));
  volumes.sourceType.current = action.val;
  if (action.val === "entire-pc") {
    for (let key in volumes.list) {
      volumes.list[key].checked = true;
      volumes.list[key].semiChecked = false;
      for (let volKey in volumes.list[key].volume) {
        volumes.list[key].volume[volKey].checked = true;
      }
    }
  }

  return updateObject(state, {
    volumes: updateObject(state.volumes, volumes)
  });
}

function toggleSourceDevice(state, action) {
  let sourceType = state.volumes.sourceType.current;
  let tempDisksList = deepClone(state.volumes.list);
  const device = { ...state.volumes.list[action.deviceId] };

  device.checked = !device.checked;
  device.semiChecked = false;

  for (let volKey in device.volume) {
    device.volume[volKey].checked = device.checked;
  }

  tempDisksList[device.deviceId] = device;
  sourceType = "entire-pc";
  Object.values(tempDisksList).forEach(disk => {
    if (Object.values(disk.volume).filter(vol => !vol.checked).length > 0) {
      sourceType = "customize";
    }
  });

  return updateObject(state, {
    volumes: updateObject(state.volumes, {
      sourceType: updateObject(state.volumes.sourceType, {
        current: sourceType
      }),
      list: updateObject(state.volumes.list, {
        [action.deviceId]: updateObject(
          state.volumes.list[action.deviceId],
          device
        )
      })
    })
  });
}

function toggleSourceVolume(state, action) {
  let sourceType = state.volumes.sourceType.current;
  let tempDisksList = deepClone(state.volumes.list);
  const device = updateObject(state.volumes.list[action.deviceId], {
    volume: updateObject(state.volumes.list[action.deviceId].volume, {
      [action.volId]: updateObject(
        state.volumes.list[action.deviceId].volume[action.volId],
        {
          checked: !state.volumes.list[action.deviceId].volume[action.volId]
            .checked
        }
      )
    })
  });
  device.checked = false;
  device.semiChecked = false;

  for (let volKey in device.volume) {
    if (device.volume[volKey].checked) {
      device.checked = true;
    }
  }

  for (let key in device.volume) {
    if (!device.volume[key].checked && device.checked) {
      device.semiChecked = true;
    }
  }
  tempDisksList[device.deviceId] = device;
  sourceType = "entire-pc";
  Object.values(tempDisksList).forEach(disk => {
    if (Object.values(disk.volume).filter(vol => !vol.checked).length > 0) {
      sourceType = "customize";
    }
  });

  return updateObject(state, {
    volumes: updateObject(state.volumes, {
      sourceType: updateObject(state.volumes.sourceType, {
        current: sourceType
      }),
      list: updateObject(state.volumes.list, {
        [action.deviceId]: device
      })
    })
  });
}

function saveBackupSettingsStart(state, action) {
  return updateObject(state, { loading: true });
}

function fetchBackupSettingsSuccess(state, action) {
  const updatedState = { ...state };

  updatedState.loading = false;
  updatedState.changed = false;

  // Updating Schedule Info
  const updatedScheduleInfo = { ...updatedState.scheduleInfo };

  updatedScheduleInfo.type.current = action.backupSettings.scheduleInfo.type;
  updatedScheduleInfo.startTime.value =
    action.backupSettings.scheduleInfo.startTime;
  updatedScheduleInfo.interval = action.backupSettings.scheduleInfo.interval;

  if (updatedScheduleInfo.type.current === 3) {
    updatedScheduleInfo.type.past = 0;
  }
  updatedScheduleInfo.weekDays = action.backupSettings.scheduleInfo.weekDays.sort();
  if (updatedScheduleInfo.type.current === 1)
    updatedScheduleInfo.weekDays = createNumberRange(7, 0);
  else
    updatedScheduleInfo.weekDays = action.backupSettings.scheduleInfo.weekDays.sort();
  updatedScheduleInfo.months = action.backupSettings.scheduleInfo.months;
  updatedScheduleInfo.monthDays = action.backupSettings.scheduleInfo.monthDays;
  updatedScheduleInfo.advanced = {
    ...action.backupSettings.scheduleInfo.advanced
  };

  //Updating Client Info
  const updatedClientDetails = updateObject(
    updatedState.clientDetails,
    action.backupSettings.clientDetails
  );

  //Updating Email Notification
  const updatedEmailNotification = { ...updatedState.emailNotification };

  updatedEmailNotification.enabled =
    action.backupSettings.emailNotification.enable;
  delete updatedEmailNotification.enable;
  updatedEmailNotification.emails.list = action.backupSettings.emailNotification
    .emails
    ? action.backupSettings.emailNotification.emails
    : [];
  updatedEmailNotification.smtpSettings =
    action.backupSettings.emailNotification.smtpSettings;
  updatedEmailNotification.notifyOnDesktop =
    action.backupSettings.emailNotification.notifyOnDesktop;
  updatedEmailNotification.reportFrequency =
    action.backupSettings.emailNotification.reportFrequency;
  updatedEmailNotification.reportStatus =
    action.backupSettings.emailNotification.reportStatus;

  switch (action.backupSettings.emailNotification.operationStatus) {
    case 0:
      updatedEmailNotification.operationStatus.onFailure = true;
      updatedEmailNotification.operationStatus.onSuccess = true;
      break;
    case 1:
      updatedEmailNotification.operationStatus.onFailure = false;
      updatedEmailNotification.operationStatus.onSuccess = true;
      break;
    case 2:
      updatedEmailNotification.operationStatus.onFailure = true;
      updatedEmailNotification.operationStatus.onSuccess = false;
      break;
    default:
      updatedEmailNotification.operationStatus.onFailure = false;
      updatedEmailNotification.operationStatus.onSuccess = false;
      break;
  }

  //Updating encryption
  const updatedEncryption = updateObject(updatedState.encryption, {
    type: action.backupSettings.encryption.type,
    key:
      action.backupSettings.encryption.key !== ""
        ? {
            value: action.backupSettings.encryption.key,
            confirmValue: action.backupSettings.encryption.key
          }
        : { value: "", confirmValue: "" }
  });

  //Updating volumes
  const updatedVolumes = { ...updatedState.volumes };

  updatedVolumes.list = {};
  action.backupSettings.volumes.forEach(val => {
    let totalSpace = 0,
      usedSpace = 0,
      checked = false,
      semiChecked = false;
    const volumes = {};

    updatedVolumes.list[val.deviceId] = { ...val };
    val.volume.forEach(volVal => {
      volVal.label = volVal.label.replace(/:/g, "");
      volumes[volVal.label] = volVal;
      totalSpace = totalSpace + volVal.totalSpace;
      usedSpace = usedSpace + volVal.usedSpace;
      if (volVal.checked) checked = true;
    });

    for (let key in volumes) {
      if (!volumes[key].checked && checked) {
        semiChecked = true;
        break;
      }
    }

    updatedVolumes.list[val.deviceId].volume = volumes;
    updatedVolumes.list[val.deviceId].totalSpace = totalSpace;
    updatedVolumes.list[val.deviceId].usedSpace = usedSpace;
    updatedVolumes.list[val.deviceId].checked = checked;
    updatedVolumes.list[val.deviceId].semiChecked = semiChecked;
  });

  let entirePC = true;
  for (let key in updatedVolumes.list) {
    if (
      (updatedVolumes.list[key].semiChecked &&
        updatedVolumes.list[key].checked) ||
      (!updatedVolumes.list[key].semiChecked &&
        !updatedVolumes.list[key].checked)
    ) {
      entirePC = false;
      break;
    }
  }
  if (entirePC) updatedVolumes.sourceType.current = "entire-pc";
  else updatedVolumes.sourceType.current = "customize";

  //Updating cleanup
  const updatedCleanup = updateObject(
    updatedState.cleanup,
    action.backupSettings.cleanup
  );

  //Updating performance
  const updatedPerformance = updateObject(updatedState.performance, {
    ignoreBadSectors: action.backupSettings.performance.ignoreBadSectors,
    priority: action.backupSettings.performance.priority,
    speed: {
      limit: action.backupSettings.performance.speed.limit,
      value:
        action.backupSettings.performance.speed.value >
        STATIC_VARIABLES.maxTrottleSpeed
          ? STATIC_VARIABLES.maxTrottleSpeed
          : action.backupSettings.performance.speed.value
    }
  });

  //Updating cutoff
  const updatedCutOffTime = action.backupSettings.cutOffTime;

  updatedState.encryption = updatedEncryption;
  updatedState.scheduleInfo = updatedScheduleInfo;
  updatedState.emailNotification = updatedEmailNotification;
  updatedState.volumes = updatedVolumes;
  updatedState.clientDetails = updatedClientDetails;
  updatedState.cleanup = updatedCleanup;
  updatedState.performance = updatedPerformance;
  updatedState.cutOffTime = updatedCutOffTime;

  return updateObject(state, updatedState);
}

function fetchBackupSettingsFailure(state, action) {
  return updateObject(state, {
    loading: false,
    failed: {
      msg: action.data.msg,
      status: action.data.status
    }
  });
}

function backupSettingsChanged(state, action) {
  return state.clientDetails &&
    action.clientUUID === state.clientDetails.clientUUID
    ? updateObject(state, {
        changed: true
      })
    : state;
}

function toggleEncryptionType(state, action) {
  return updateObject(state, {
    encryption: updateObject(state.encryption, {
      type: action.encryption
    })
  });
}

function changeEncryptionKey(state, action) {
  return updateObject(state, {
    encryption: updateObject(state.encryption, {
      key: updateObject(state.encryption.key, {
        [action.key]: action.value
      })
    })
  });
}

function fetchBackupSettingsStart(state, action) {
  return updateObject(state, {
    loading: true
  });
}

function saveBackupSettingsSuccess(state, action) {
  return updateObject(state, {
    loading: false
  });
}

function cancelEditBackupSetting(state, action) {
  return updateObject(state, action.settings);
}

function closeRefresh(state, action) {
  return updateObject(state, {
    changed: false,
    preChanged: false
  });
}

function clearBackupSettings(state, action) {
  return initState;
}

function toggleCleanupScheduleCount(state, action) {
  if (+action.scheduleCount < 1 || +action.scheduleCount > 999) return state;
  return updateObject(state, {
    cleanup: updateObject(state.cleanup, {
      scheduleCount: +action.scheduleCount
    })
  });
}

function toggleCleanupMonths(state, action) {
  if (+action.months < 1 || +action.months > 99) return state;
  return updateObject(state, {
    cleanup: updateObject(state.cleanup, {
      months: updateObject(state.cleanup.months, {
        value: +action.months
      })
    })
  });
}

function toggleCleanupMonthsCheck(state) {
  return updateObject(state, {
    cleanup: updateObject(state.cleanup, {
      months: updateObject(state.cleanup.months, {
        checked: !state.cleanup.months.checked
      })
    })
  });
}

function togglePerformanceSpeedLimit(state) {
  return updateObject(state, {
    performance: updateObject(state.performance, {
      speed: updateObject(state.performance.speed, {
        limit: !state.performance.speed.limit ? 1 : 0
      })
    })
  });
}

function togglePerformancePriority(state, action) {
  return updateObject(state, {
    performance: updateObject(state.performance, {
      priority: +action.priority
    })
  });
}

function togglePerformanceSpeed(state, action) {
  if (+action.speed < 1 || +action.speed > 999) return state;
  let speed = null;
  if (action.unit === "Mbps") speed = +action.speed * 1000 * 1000;
  else if (action.unit === "Kbps") speed = +action.speed * 1000;
  return updateObject(state, {
    performance: updateObject(state.performance, {
      speed: updateObject(state.performance.speed, {
        value: speed
      })
    })
  });
}

function toggleSkipDiskErr(state, action) {
  return updateObject(state, {
    performance: updateObject(state.performance, {
      ignoreBadSectors: +action.ignoreBadSectors
    })
  });
}

function preBackupSettingsChanged(state, action) {
  if (
    state.clientDetails &&
    action.clientUUID === state.clientDetails.clientUUID
  ) {
    return updateObject(state, {
      preChanged: true
    });
  } else return state;
}

function accountSettingsChanged(state) {
  return updateObject(state, {
    changed: true
  });
}

function toggleCutOffTime(state, action) {
  let hours = Math.trunc(state.cutOffTime.value / 3600);
  let minutes = Math.trunc((state.cutOffTime.value % 3600) / 60);
  let seconds = state.cutOffTime.value % 60;
  let val = parseInt(action.val) || 0;

  if (action.time === "hr") {
    hours = Math.min(23, Math.max(0, val));
  } else if (action.time === "mn") {
    minutes = Math.min(59, Math.max(0, val));
  } else if (action.time === "ss") {
    seconds = Math.min(59, Math.max(0, val));
  }

  return updateObject(state, {
    cutOffTime: updateObject(state.cutOffTime, {
      value: hours * 3600 + minutes * 60 + seconds
    })
  });
}

function toggleCutOffEnable(state, action) {
  return updateObject(state, {
    cutOffTime: updateObject(state.cutOffTime, {
      isEnabled: action.enable ? 1 : 0
    })
  });
}

function removeMachineFromHeaderSuccess(state, action) {
  const temp = [...state.removeMachineFromHeaderResponse];
  temp.push("SUCCESS");
  return updateObject(state, {
    removeMachineFromHeaderResponse: temp
  });
}

function removeMachineFromHeaderFailure(state, action) {
  const temp = [...state.removeMachineFromHeaderResponse];
  temp.push("FAILURE");
  return updateObject(state, {
    removeMachineFromHeaderResponse: temp
  });
}

function resetRemoveMachinesList(state, action) {
  return updateObject(state, {
    removeMachineFromHeaderResponse: []
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.TOGGLE_SCHEDULE_TYPE:
      return toggleScheduleType(state, action);
    case types.TOGGLE_SCHEDULE_INTERVAL:
      return toggleScheduleInterval(state, action);
    case types.TOGGLE_SCHEDULE_START_TIME:
      return toggleScheduleStartTime(state, action);
    case types.TOGGLE_SCHEDULE_DAYS:
      return toggleScheduleDays(state, action);
    case types.TOGGLE_SCHEDULE_MONTHS:
      return toggleScheduleMonths(state, action);
    case types.TOGGLE_SCHEDULE_MONTH_DAYS:
      return toggleScheduleMonthDays(state, action);
    case types.TOGGLE_SCHEDULE_RETENTION:
      return toggleScheduleRetention(state, action);
    case types.TOGGLE_SCHEDULE_DEVICE:
      return toggleScheduleDevice(state, action);
    case types.TOGGLE_SCHEDULE_LOGIN_DETAILS:
      return toggleScheduleLoginDetails(state, action);
    case types.TOGGLE_NOTIFICATION_ENABLE:
      return toggleNotificationEnable(state, action);
    case types.CHANGE_NOTIFICATION_CURRENT_EMAIL:
      return changeNotificationCurrentEmail(state, action);
    case types.ADD_NOTIFICATION_EMAIL:
      return addNotificationEmail(state, action);
    case types.ADD_MULTIPLE_NOTIFICATION_EMAIL:
      return addMultipleNotificationEmail(state, action);
    case types.TOGGLE_NOTIFICATION_REMOVE_EMAIL:
      return removeNotificationEmail(state, action);
    case types.CHANGE_NOTIFICATION_SMTP_SETTING:
      return changeNotificationSMTPSetting(state, action);
    case types.TOGGLE_NOTIFICATION_OPERATION_STATUS:
      return toggleNotificationOperationStatus(state, action);
    case types.TOGGLE_NOTIFY_ON_DESKTOP:
      return toggleNotificationOnDesktop(state, action);
    case types.TOGGLE_SOURCE_TYPE:
      return toggleSourceType(state, action);
    case types.TOGGLE_SOURCE_DEVICE:
      return toggleSourceDevice(state, action);
    case types.TOGGLE_SOURCE_VOLUME:
      return toggleSourceVolume(state, action);
    case types.FETCH_BACKUP_SETTINGS_START:
      return fetchBackupSettingsStart(state, action);
    case types.FETCH_BACKUP_SETTINGS_SUCCESS:
      return fetchBackupSettingsSuccess(state, action);
    case types.FETCH_BACKUP_SETTINGS_FAILURE:
      return fetchBackupSettingsFailure(state, action);
    case types.BACKUP_SETTINGS_CHANGED:
      return backupSettingsChanged(state, action);
    case types.TOGGLE_ENCRYPTION_TYPE:
      return toggleEncryptionType(state, action);
    case types.CHANGE_ENCRYPTION_KEY:
      return changeEncryptionKey(state, action);
    case types.CANCEL_EDIT_BACKUP_SETTING:
      return cancelEditBackupSetting(state, action);
    case types.SAVE_BACKUP_SETTINGS_START:
      return saveBackupSettingsStart(state, action);
    case types.SAVE_BACKUP_SETTINGS_SUCCESS:
      return saveBackupSettingsSuccess(state, action);
    case types.CLOSE_REFRESH:
      return closeRefresh(state, action);
    case types.CLEAR_BACKUP_SETTINGS:
      return clearBackupSettings(state, action);
    case types.TOGGLE_CLEANUP_SCHEDULE_COUNT:
      return toggleCleanupScheduleCount(state, action);
    case types.TOGGLE_CLEANUP_MONTHS:
      return toggleCleanupMonths(state, action);
    case types.TOGGLE_CLEANUP_MONTHS_CHECK:
      return toggleCleanupMonthsCheck(state);
    case types.TOGGLE_PERFORMANCE_SPEED_LIMIT:
      return togglePerformanceSpeedLimit(state);
    case types.TOGGLE_PERFORMANCE_SPEED:
      return togglePerformanceSpeed(state, action);
    case types.TOGGLE_PERFORMANCE_PRIORITY:
      return togglePerformancePriority(state, action);
    case types.TOGGLE_SKIP_DISK_ERR:
      return toggleSkipDiskErr(state, action);
    case types.PRE_BACKUP_SETTINGS_CHANGED:
      return preBackupSettingsChanged(state, action);
    case types.ACCOUNT_SETTINGS_CHANGED:
      return accountSettingsChanged(state);
    case types.TOGGLE_CUT_OFF_TIME:
      return toggleCutOffTime(state, action);
    case types.TOGGLE_CUT_OFF_ENABLE:
      return toggleCutOffEnable(state, action);
    case types.REMOVE_MACHINE_FROM_HEADER_SUCCESS:
      return removeMachineFromHeaderSuccess(state, action);
    case types.REMOVE_MACHINE_FROM_HEADER_FAILURE:
      return removeMachineFromHeaderFailure(state, action);
    case types.RESET_REMOVE_MACHINES_LIST:
      return resetRemoveMachinesList(state, action);
    default:
      return state;
  }
}

export default reducer;
